



















































import {Component, Vue} from 'vue-property-decorator'
import HeaderBar from '@/components/HeaderBar.vue'
import MenusStore from "@/store/modules/MenusStore";
import DialogButtons from "@/components/Dialog/parts/DialogButtons.vue";
import SchedulesStore from "@/store/modules/SchedulesStore";
import ScheduleEditor from "@/pages/SchedulePages/ScheduleEditor.vue";
import DeleteScheduleDialog from "@/components/Dialog/DeleteScheduleDialog.vue";
import {CmsApiUtil} from "@/_common/api/utils/cms_api_utils";
import Navigator from '@/components/Navigator.vue';

@Component({
    components: {
        DeleteScheduleDialog,
        HeaderBar,
        Navigator,
        DialogButtons,
        ScheduleEditor,
    },
})
export default class ScheduleEditPage extends Vue {

    private isDeleteDialog: boolean = false;
    private selected: string = "period";

    async created() {
        MenusStore.init();
        SchedulesStore.init(this.menuId);
        this.selected = String(this.$route.query.selected);
    }

    get menuId(): number {
        return Number(this.$route.params.menuId);
    }

    get menu(): CMS.Menu {
        return MenusStore.menuById[this.menuId] || {};
    }

    get scheduleId(): number {
        return Number(this.$route.params.scheduleId);
    }

    get schedule(): CMS.Schedule {
        return SchedulesStore.scheduleById[this.scheduleId] || {};
    }

    get scheduleList(): CMS.Schedule[] {
        if (this.selected === 'period') {
            return SchedulesStore.period;
        } else {
            return SchedulesStore.day;
        }
    }

    get dirty(): boolean {
        return SchedulesStore.dirty;
    }

    private onScheduleChange(schedule: CMS.Schedule) {
        SchedulesStore.localEdit(schedule);
    }

    private onClickCancel() {
        SchedulesStore.cancelEdit();
        this.$router.push({name: 'menu_top'})
    }

    private onClickUpdate() {
        SchedulesStore.applyEdit();
        this.$router.push({name: 'menu_top'})
    }

    private onClickDelete() {
        this.isDeleteDialog = true;
    }

    private onOkDelete() {
        SchedulesStore.delete(this.scheduleId);
        this.$router.push({name: 'menu_top'})
    }

    private onCancelDelete() {
        this.isDeleteDialog = false;
    }

    private hasError(schedule: CMS.Schedule): boolean {
        if (this.selected == "period" && !CmsApiUtil.isValidDatePeriod(schedule.start_date, schedule.end_date)) {
            return true;
        }
        if (this.selected == "period" && !CmsApiUtil.isDuplicatePeriod(schedule, this.scheduleList)) {
            return true;
        }
        if (this.selected == "day" && !CmsApiUtil.isDuplicateDay(schedule, this.scheduleList)) {
            return true;
        }

        return false;
    }
}
